import { Routes, Route } from "react-router-dom";
import { useEffect, Suspense, lazy } from "react";
import { Toaster } from "react-hot-toast";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Loader from "./components/Loader";
import "./App.css";

const Home = lazy(() => import("./components/pages/Home"));
const AddPlace = lazy(() => import("./components/pages/addPlace"));
const Explore = lazy(() => import("./components/pages/Explore"));
const Favorites = lazy(() => import("./components/pages/favorites"));
const Login = lazy(() => import("./components/pages/login"));
const PlaceDetail = lazy(() => import("./components/pages/PlaceDetail"));
const About = lazy(() => import("./components/pages/About"));
const Terms = lazy(() => import("./components/pages/Terms"));
const Privacy = lazy(() => import("./components/pages/Privacy"));
const Guidelines = lazy(() => import("./components/pages/Guidelines"));
const Error = lazy(() => import("./components/pages/Error"));

function App() {
  useEffect(() => {
    import("./components/pages/Home");

    const timeout = setTimeout(() => {
      import("./components/pages/Explore");
    }, 3000);

    return () => clearTimeout(timeout);
  }, []);

  return (
    <div className="container">
      <div className="navigation">
        <Navbar />
      </div>
      <div className="main">
        <Toaster
          position="top-right"
          toastOptions={{
            duration: 3000,
            style: {
              background: "#fff",
              color: "#333",
              fontSize: "17px",
              borderRadius: "8px",
              padding: "0.5rem",
              border: "1px solid #ccc",
            },
            success: {
              iconTheme: {
                primary: "#692a99",
                secondary: "#fff",
              },
            },
            error: {
              style: {
                background: "#ffeaea",
                color: "#b00020",
              },
            },
          }}
        />
        <Suspense fallback={<Loader />}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/add-place" element={<AddPlace />} />
            <Route path="/explore" element={<Explore />} />
            <Route path="/favorites" element={<Favorites />} />
            <Route path="/login" element={<Login />} />
            <Route path="/place/:id" element={<PlaceDetail />} />
            <Route path="/about" element={<About />} />
            <Route path="/terms-and-conditions" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/guidelines" element={<Guidelines />} />
            <Route path="*" element={<Error />} />
          </Routes>
        </Suspense>
      </div>
      <footer>
        <Footer />
      </footer>
    </div>
  );
}

export default App;
